import React, { useEffect, useMemo } from 'react';
import Dashboard from '../../../components/shared/dashboard/dashboard';
import { EventsListAdminPageStyled } from './events-list-admin.styled';
import List from '../../../components/shared/list/list';
import {
  ListStyled, sxList,
} from '../../../components/shared/list/list.styled';
import i18n from '../../../translations/strings';
import {
  getDateTimeBooking,
  getDisplayNameEventStatus,
  getDisplayNamePaymentEventStatus,
  getRoom,
  getSmartObject,
  getStringDateName,
} from '../../../utils/utils';
import { getEventsListAction, getEventsListResetState } from '../../../store/shared/events-list.store';
import { useDispatch, useSelector } from 'react-redux';
import { ModalVariant } from '../../../components/shared/modal-provider/components/modal/modal.constants';
import { useModal } from '../../../components/shared/modal-provider/hooks/modal-provider.hook';
import { SvgImage, SvgType } from '../../../components/base/svg/svg';
import { useNavigate } from 'react-router-dom';
import TableCell from '@mui/material/TableCell';

const statuses = ['CONFIRMED', 'SENT', 'CANCELED_BY_ADMIN'];
const EventsListAdminPage = () => {

  const {
    eventsList,
    paginationInfo,
    loading,
    error,
    rooms,
    smartObjects,
  } = useSelector((state: any) => {
    return state.eventsList;
  });

  const { openModal } = useModal();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (error) {
      openModal({
        message: error,
        variant: ModalVariant.Error,
        handleCloseModal: () => dispatch(getEventsListResetState()),
      });
    }
  }, [error]);


  const fields = useMemo(() => {
    return [
      {
        name: 'id',
        displayName: i18n.t('eventsList.id'),
        component: (item: any) => {
          return <ListStyled.CustomRow>{item.reference_number ? item.reference_number : item.id}</ListStyled.CustomRow>;
        },
      },
      {
        name: 'date',
        displayName: i18n.t('eventsList.date'),
        component: (item: any) => {
          const date = getStringDateName(item.start);
          return <ListStyled.CustomRow>{date}</ListStyled.CustomRow>;
        },
      },
      {
        name: 'time',
        displayName: i18n.t('eventsList.time'),
        component: (item: any) => {
          const { time: timeStart } = getDateTimeBooking(item.start);
          const { time: timeEnd } = getDateTimeBooking(item.end);
          return <ListStyled.CustomRow>
                {i18n.t('reservations.timeStartEnd', {
                  start: timeStart,
                  end: timeEnd,
                })}
            </ListStyled.CustomRow>
        },
      },
      {
        name: 'reservation',
        displayName: i18n.t('eventsList.reservation'),
        component: (item: any) => {
          const date = getStringDateName(item.booking.created_at);
          return <ListStyled.CustomRow>{date}</ListStyled.CustomRow>;
        },
      },
      {
        name: 'customer',
        displayName: i18n.t('eventsList.organiser'),
        component: (item: any) => {
          return (
            <ListStyled.CustomRow>
              {item.booking.user_information.full_name}
            </ListStyled.CustomRow>
          );
        },
      },
      {
        name: 'event_status',
        displayName: i18n.t('eventsList.eventStatus'),
        component: (item: any) => {
          return <ListStyled.CustomRow>{getDisplayNameEventStatus(item.event_status)}</ListStyled.CustomRow>;
        },
      },
      {
        name: 'payment',
        displayName: i18n.t('eventsList.payment'),
        component: (item: any) => {
          return <ListStyled.CustomRow>{getDisplayNamePaymentEventStatus(item.payment_status)}</ListStyled.CustomRow>;
        },
      },
      {
        name: 'room',
        displayName: i18n.t('eventsList.room'),
        component: (item: any) => {
          const room = getRoom(rooms, item.product);
          return (
            <ListStyled.CustomRow>
                {room?.name}
            </ListStyled.CustomRow>
          );
        },
      },
      {
        name: 'edit',
        displayName: i18n.t('reservations.edit'),
        component: (item: any) => (
          <ListStyled.ContainerEdit>
            <ListStyled.ContainerEditBooking
              onClick={() =>
                navigate(`/admin/handle-reservation-admin/${item.booking.id}`)
              }
            >
              <SvgImage type={SvgType.Edit} />
            </ListStyled.ContainerEditBooking>
          </ListStyled.ContainerEdit>
        ),
      },
    ];
  }, [rooms, smartObjects, eventsList]);


  return (
    <Dashboard callingPage={'EventsListAdminPage'}>
      <EventsListAdminPageStyled.Container>
        <EventsListAdminPageStyled.ListContainer>
          <List
            showMoreButton={false}
            containerComponent={EventsListAdminPageStyled.ListContainer}
            data={eventsList}
            paginationInfo={paginationInfo}
            fields={fields}
            getDataAction={getEventsListAction}
            loading={loading}
            statuses={statuses}
          />
        </EventsListAdminPageStyled.ListContainer>
      </EventsListAdminPageStyled.Container>
    </Dashboard>
  );
};

export default EventsListAdminPage;
